import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../interceptors/authErrorInterceptor';
import { TaxRulesRequest, TaxRuleResponse } from './taxRulesService.types';
import axiosBaseQuery from '../axiosBaseQuery';
import { adapter } from '../adapters';

export const taxRulesService = createApi({
  reducerPath: 'taxRules',
  baseQuery: baseQueryWithReauth(axiosBaseQuery(adapter)),
  endpoints: (builder) => ({
    getTaxRules: builder.mutation<TaxRuleResponse[], TaxRulesRequest>({
      query: (body) => ({
        url: '/rates:query',
        method: 'post',
        body,
      }),
    }),
  }),
});

export const { useGetTaxRulesMutation } = taxRulesService;
